
import BoxCategoryEditComponent from "../../../components/box_categories/Edit.vue";

export default {
  components: {
    BoxCategoryEditComponent
  }
}
